import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import useMoney from '../../../../../hooks/useMoney';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { useOrderCalculateContext } from '../../../contexts/OrderCalculate.context';
import { Order } from '../../../order.types';

interface OrderObjectOverviewTabProps {
  order: Order;
}

const OrderObjectOverviewTab = ({ order }: OrderObjectOverviewTabProps) => {
  const { translate, locale } = useTranslation();
  const { formatMoney } = useMoney();
  const { summaryTotals } = useOrderCalculateContext();

  const totals = summaryTotals?.calculate?.total;

  const cards: { label: LangEnum; value: string }[] = [
    {
      label: LangEnum.GLOBAL_ITEMS,
      value: (totals?.quantity ?? order.totalItems).toLocaleString(locale),
    },
    {
      label: LangEnum.GLOBAL_PIECES,
      value: (totals?.pieces ?? order.totalPieces).toLocaleString(locale),
    },
    { label: LangEnum.GLOBAL_GROSS_VALUE, value: formatMoney(totals?.subtotal ?? order.subTotal) },
    {
      label: LangEnum.GLOBAL_DISCOUNTS_AND_CHARGES,
      value: formatMoney(totals?.discount ?? order.totalDiscountValue),
    },
    { label: LangEnum.GLOBAL_NET_VALUE, value: formatMoney(totals?.total ?? order.totalValue) },
  ];

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2 }}>
      {cards.map((card) => (
        <Stack
          key={card.label}
          sx={{
            gap: 0.5,
            p: 2,
            border: 1,
            borderRadius: (theme) => `${theme.shape.borderRadius2xl}px`,
            borderColor: (theme) => theme.palette.custom.border.secondary,
          }}
        >
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            {translate(card.label)}
          </Typography>
          <Typography variant="h4">{card.value}</Typography>
        </Stack>
      ))}
    </Box>
  );
};

export default OrderObjectOverviewTab;
